import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const parse = (text) => text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean).map((l) => {
  const parts = l.split(/[,\t;]/).map((x) => x.trim().replace(/^"|"$/g, ""));
  return parts.length >= 2 ? { match: parts[0], code: parts[parts.length - 1] } : null;
}).filter(Boolean).filter((r) => !/^(ref|ibs|match|name|barcode|id)$/i.test(r.match));

export default function SapCodesImportDialog({ open, onClose, onDone }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const rows = parse(text);
  const run = async () => {
    setBusy(true);
    try { const r = await adminApi.importSapCodes(rows); setResult(r); toast.success(`${r.updated_count} flower(s) updated`); onDone(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { onClose(); setResult(null); } }}>
      <DialogContent className="max-w-lg" data-testid="sap-codes-modal">
        <DialogHeader><DialogTitle className="font-serif">Bulk import SAP material codes</DialogTitle></DialogHeader>
        <p className="text-sm text-[#28282E]/70">Paste one line per product: <code className="rounded bg-slate-100 px-1">IBS ref (or barcode / name), SAP code</code>. Also accepts tab-separated columns copied from Excel.</p>
        <textarea data-testid="sap-codes-input" value={text} onChange={(e) => setText(e.target.value)} rows={8} placeholder={"841045,100234\n9315644015077,100235\nSmall Posy,100240"} className="w-full rounded-md border border-slate-200 p-2 font-mono text-xs" />
        <p className="text-xs text-[#28282E]/55">{rows.length} row(s) ready</p>
        {result && <div data-testid="sap-codes-result" className="rounded-lg bg-[#FBEEF4] p-3 text-xs"><div className="font-semibold">{result.updated_count} updated</div>{result.unmatched.length > 0 && <div className="mt-1 text-red-700">Unmatched: {result.unmatched.join(", ")}</div>}</div>}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Close</Button>
          <Button data-testid="sap-codes-import" onClick={run} disabled={busy || rows.length === 0} className="bg-[#28282E] text-white hover:bg-[#1F1F24]">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Upload className="mr-2 h-4 w-4" />} Import</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
